<template>
    <div class="caisse-app" :class="{ 'dark-mode': isDarkMode }">
        <!-- ==================== HEADER ==================== -->
        <div class="mapp-header">
            <div class="mheader-brand">
                <div class="brand-icon">
                    <i class="ri-store-2-fill"></i>
                </div>
                <div class="brand-info">
                    <span class="brand-title">CAISSE</span>
                    <span class="brand-date">{{ Items.datedoc }}</span>
                </div>
            </div>

            <div class="header-balance">
                <span class="balance-label">Solde caisse</span>
                <span class="balance-value">{{ formatNumber($store.state.montantencaisse) }} F</span>
            </div>

            <div class="header-actions">
                <button
                        class="action-btn-header"
                        :class="{ 'has-badge': nbrefactureenattante > 0 }"
                        @click="btnupdatefactureselected"
                        title="Factures en attente"
                >
                    <i class="ri-file-list-3-line"></i>
                    <span v-if="nbrefactureenattante > 0" class="badge">{{ nbrefactureenattante }}</span>
                </button>

                <button class="action-btn-header" @click="btnmodalpointdelacaisse5" title="Rapport">
                    <i class="ri-pie-chart-line"></i>
                </button>

                <button class="action-btn-header" @click="toggleTheme" title="Thème">
                    <i :class="isDarkMode ? 'ri-sun-line' : 'ri-moon-line'"></i>
                </button>

                <div class="dropdown-wrapper">
                    <button class="action-btn-header" @click="toggleMenu">
                        <i class="ri-more-2-fill"></i>
                    </button>
                    <transition name="fade-slide">
                        <div v-if="showDropdown" class="dropdown-panel" @click.stop>
                            <button @click="handlebtnreinitialiserAllarticle(); showDropdown = false">
                                <i class="ri-refresh-line text-blue-500"></i>
                                <span>Synchroniser articles</span>
                            </button>
                            <button @click="btnmoadalindextransfertdefonddecaisse('DPC', $store.state.typc); showDropdown = false">
                                <i class="ri-exchange-funds-line text-green-500"></i>
                                <span>Transfert de fonds</span>
                            </button>
                            <button @click="btnmodalrecapitulatifca(); showDropdown = false">
                                <i class="ri-bar-chart-box-line text-purple-500"></i>
                                <span>Analyse CA</span>
                            </button>
                            <button @click="btnmodalpointdelacaisse5(); showDropdown = false">
                                <i class="ri-bar-chart-box-line text-purple-500"></i>
                                <span>Point de la caisse</span>
                            </button>
                            <button @click="btnmodalpointdelacaisse6(); showDropdown = false">
                                <i class="ri-bar-chart-box-line text-purple-500"></i>
                                <span>Analyse de caisse</span>
                            </button>
                            <hr />
                          <button @click="btnmodallistedesfacturactionsalacaisse('FVC'); showDropdown = false">
                            <i class="ri-bar-chart-box-line text-purple-500"></i>
                            <span>Listes des facturations effectuées au cours d'une période</span>
                          </button>
                          <hr />
                            <button @click="newinvoice(); showDropdown = false">
                                <i class="ri-add-circle-line text-cyan-500"></i>
                                <span>Nouvelle facture</span>
                            </button>
                            <button @click="note(); showDropdown = false" :disabled="!listedatatable.length">
                                <i class="ri-printer-line text-orange-500"></i>
                                <span>Imprimer note</span>
                            </button>
                            <hr />
                            <button class="danger" @click="btnmoadalfermercaisse(); showDropdown = false">
                                <i class="ri-logout-box-r-line"></i>
                                <span>Fermer la caisse</span>
                            </button>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

        <!-- ==================== ALERTS ==================== -->
        <!--transition name="alert-slide">
            <div v-if="messagesucces" class="alert success">
                <i class="ri-checkbox-circle-fill"></i>
                 <div v-html="messagesucces"></div>
                <button @click="messagesucces = ''"><i class="ri-close-line"></i></button>
            </div>
        </transition>

        <transition name="alert-slide">
            <div v-if="messageerror" class="alert error">
                <i class="ri-error-warning-fill"></i>
                <div v-html="messageerror"></div>
                <button @click="messageerror = ''"><i class="ri-close-line"></i></button>
            </div>
        </transition-->

        <transition name="alert-slide">
    <div v-if="messagesucces" class="alert alert-success flex items-start gap-2" role="alert">
        <i class="ri-checkbox-circle-fill mt-0.5"></i>
        <div class="flex-1" v-html="messagesucces"></div>
        <button type="button" aria-label="Fermer" @click="messagesucces = ''">
            <i class="ri-close-line"></i>
        </button>
    </div>
</transition>

<transition name="alert-slide">
    <div v-if="messageerror" class="alert alert-danger flex items-start gap-2" role="alert">
        <i class="ri-error-warning-fill mt-0.5"></i>
        <div class="flex-1" v-html="messageerror"></div>
        <button type="button" aria-label="Fermer" @click="messageerror = ''">
            <i class="ri-close-line"></i>
        </button>
    </div>
</transition>

        <!-- ==================== MAIN CONTENT ==================== -->
        <main class="app-main">
            <!-- LEFT PANEL: Scanner & Articles -->
            <aside class="panel-left">
                <!-- Scanner Section -->
                <section class="scanner-section">
                    <div class="section-title">
                        <i class="ri-barcode-box-line"></i>
                        <span>Scanner</span>
                    </div>

                    <!-- PRE-SCAN QUANTITY -->
                    <div class="prescan-box">
                        <label>Quantité à scanner</label>
                        <div class="qty-stepper">
                            <button @click="prescanQty > 1 && prescanQty--" :disabled="prescanQty <= 1">
                                <i class="ri-subtract-line"></i>
                            </button>
                            <input
                                    type="number"
                                    v-model.number="prescanQty"
                                    min="1"
                                    @keydown.enter="$refs.barcodeInput.focus()"
                            />
                            <button @click="prescanQty++">
                                <i class="ri-add-line"></i>
                            </button>
                        </div>
                        <small><i class="ri-information-line"></i> Définir avant de scanner</small>
                    </div>

                    <!-- BARCODE INPUT -->
                    <div class="input-group barcode">
                        <i class="ri-qr-scan-2-line"></i>
                        <input
                                ref="barcodeInput"
                                v-model="lecteurdecodebarre"
                                type="text"
                                placeholder="Scanner le code-barres..."
                                @keydown.enter="handleBarcodeScan"
                                autocomplete="off"
                        />
                        <div class="scan-status" :class="{ active: scanActive }"></div>
                    </div>

                    <!-- SEARCH INPUT -->
                    <div class="input-group search">
                        <i class="ri-search-line"></i>
                        <input
                                v-model="searchword"
                                type="text"
                                placeholder="Rechercher un article..."
                                @focus="showArticleList = true"
                        />
                        <button v-if="searchword" @click="searchword = ''; showArticleList = false" class="clear-input">
                            <i class="ri-close-line"></i>
                        </button>
                    </div>
                </section>

                <!-- Articles List -->
                <!--section class="articles-section" v-show="showArticleList || searchword"-->
                <section class="articles-section" >
                    <div class="section-header">
                        <span>{{ filterdatatable.length }} article(s)</span>
                        <!--button @click="showArticleList = false; searchword = ''">
                            <i class="ri-close-line"></i>
                        </button-->
                    </div>

                    <div class="articles-grid">
                        <div
                                v-for="(article, idx) in filterdatatable"
                                :key="idx"
                                class="article-card"
                                :class="{ selected: selectedArticle?.pid === article.pid }"
                                @click="selectArticle(article)"
                                @dblclick="openQuantityModal(article)"
                        >
                            <div class="article-main">
                                <span class="article-name">{{ article.libelle }}</span>
                                <span class="article-code" v-if="article.codebarre">{{ article.codebarre }}</span>
                            </div>
                            <div class="article-price">
                                {{ formatNumber(isNormalisationEtat ? article.pu7 : article.pu) }} F
                            </div>
                            <!--button class="quick-add" @click.stop="quickAddToCart(article)" title="Ajouter">
                                <i class="ri-add-line"></i>
                            </button-->
                            <button class="quick-add" @click.stop="openQuantityModal(article)" title="Ajouter">
                                <i class="ri-add-line"></i>
                            </button>
                        </div>
                    </div>

                    <div class="pagination-bar" v-if="pages.length > 1">
                        <button @click="page--" :disabled="page <= 1">
                            <i class="ri-arrow-left-s-line"></i>
                        </button>
                        <span>{{ page }} / {{ pages.length }}</span>
                        <button @click="page++" :disabled="page >= pages.length">
                            <i class="ri-arrow-right-s-line"></i>
                        </button>
                    </div>
                </section>

                <!-- Client Info (Collapsible) -->
                <section class="client-section hidden" v-if="viewclientBloc">
                    <div class="section-title clickable" @click="showClientForm = !showClientForm">
                        <i class="ri-user-3-line"></i>
                        <span>Client & Règlement</span>
                        <i :class="showClientForm ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class="toggle-icon"></i>
                    </div>

                    <transition name="expand">
                        <div v-show="showClientForm" class="client-form">
                            <div class="form-field">
                                <label>Client</label>
                                <select v-model="Items.jsonotherdonne.cltfrs" @change="handleClientSelect">
                                    <option :value="null">-- Sélectionner --</option>
                                    <option v-for="(c, i) in otherdatatable.beneficiairecl" :key="i" :value="c">
                                        {{ c.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-row">
                                <div class="form-field">
                                    <label>IFU</label>
                                    <input v-model="Items.jsonv.ifu" placeholder="IFU" />
                                </div>
                                <div class="form-field">
                                    <label>Nom</label>
                                    <input v-model="Items.jsonv.client" placeholder="Nom client" />
                                </div>
                            </div>

                            <div class="form-field">
                                <label>Mode de règlement</label>
                                <select v-model="Items.jsonv.modereglement">
                                    <option :value="null">-- Sélectionner --</option>
                                    <option v-for="(m, i) in otherdatatable.modedereglement" :key="i" :value="m">
                                        {{ m.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="form-field">
                                <label>Serveur</label>
                                <select v-model="Items.jsonv.collaborateur">
                                    <option :value="null">-- Sélectionner --</option>
                                    <option v-for="(s, i) in otherdatatable.collaborateur" :key="i" :value="s">
                                        {{ s.typecollaborateur }} / {{ s.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </transition>
                </section>
            </aside>

            <!-- CENTER PANEL: Cart / Ticket -->
            <section class="panel-center">
                <div class="cart-container">
                    <!-- Cart Header -->
                    <div class="cart-header">
                        <div class="cart-title">
                            <i class="ri-shopping-cart-2-fill"></i>
                            <span>Ticket</span>
                            <span class="cart-count" v-if="listedatatable.length">{{ listedatatable.length }}</span>
                        </div>
                        <button v-if="listedatatable.length" @click="clearCart" class="clear-cart" title="Vider">
                            <i class="ri-delete-bin-line"></i>
                        </button>
                    </div>

                    <!-- Cart Items -->
                    <div class="cart-items" ref="cartScroll">
                        <transition-group name="cart-item">
                            <div
                                    v-for="(item, idx) in listedatatable"
                                    :key="item.linekey || idx"
                                    class="cart-item"
                                    :class="getItemStatusClass(item)"
                            >
                                <!-- Status Icon -->
                                <div class="item-status">
                                    <i v-if="item.etatline == 1" class="ri-checkbox-circle-fill success"></i>
                                    <i v-else-if="item.etatline == 2" class="ri-error-warning-fill error"></i>
                                    <span v-else class="spinner-small"></span>
                                </div>

                                <!-- Item Info -->
                                <div class="item-info">
                  <span class="item-name">
                    {{ item.article.libelle }}
                    <small v-if="item.autredesignation">({{ item.autredesignation }})</small>
                  </span>
                                    <span class="item-details">
                    {{ formatNumber(item.pu) }} × {{ formatNumber2(item.qtite) }}
                    <span v-if="item.remise > 0" class="discount">-{{ formatNumber(item.remise) }}</span>
                  </span>
                                </div>

                                <!-- Item Total -->
                                <span class="item-total">{{ formatNumber(item.calmtntht) }} F</span>

                                <!-- Actions -->
                                <div class="item-actions">
                                    <button @click="btnupdateqteitem(item)" title="Modifier">
                                        <i class="ri-edit-line"></i>
                                    </button>
                                    <button @click="deleteItemArticle(item)" title="Supprimer">
                                        <i class="ri-delete-bin-line"></i>
                                    </button>
                                </div>

                                <!-- Error Message -->
                                <div v-if="item.etatline == 2 && item.linemessage" v-html="item.linemessage" class="item-error">

                                </div>
                            </div>
                        </transition-group>

                        <!-- Empty State -->
                        <div v-if="!listedatatable.length" class="cart-empty">
                            <i class="ri-shopping-cart-line"></i>
                            <p>Panier vide</p>
                            <small>Scannez ou recherchez un article</small>
                        </div>
                    </div>

                    <!-- Cart Footer / Payment -->
                    <div v-if="listedatatable.length" class="cart-footer">
                        <!-- Totals -->
                        <div class="totals-section ">
                            <div class="total-line">
                                <span>Sous-total HT</span>
                                <span>{{ currencyFormatDE(Items.mtnt.doccalmtnttotalht) }} F</span>
                            </div>
                            <div v-if="Items.mtnt.docmtntremise > 0" class="total-line discount">
                                <span>Remise</span>
                                <span>-{{ currencyFormatDE(Items.mtnt.docmtntremise) }} F</span>
                            </div>
                            <div class="total-line grand">
                                <span>NET À PAYER</span>
                                <span>{{ currencyFormatDE(Items.mtnt.docmtnttotalttc) }} F</span>
                            </div>
                        </div>

                        <!-- Payment Input -->
                        <div class="payment-section">

                            <div class="grid lg:grid-cols-2 gap-6">

                                <div class="payment-field">
                                    <label>Montant reçu</label>
                                    <div class="payment-input-wrap">
                                        <input
                                                type="number"
                                                v-model.number="Items.jsonotherdonne.montantrecu"
                                                placeholder="0"
                                                @keydown.enter="validateSale"
                                                ref="paymentInput"
                                        />
                                        <span class="currency-suffix">F</span>
                                    </div>
                                </div>

                                <div class="change-display" :class="{ negative: reliquatValue < 0 }">
                                    <span>Monnaie</span>
                                    <span class="change-value">{{ reliquat }} F</span>
                                </div>


                            </div>

                            <!-- Quick Amount Buttons -->
                            <div class="quick-amounts">
                                <button v-for="amt in [500, 1000, 2000, 5000, 10000,20000,30000]" :key="amt" @click="Items.jsonotherdonne.montantrecu = amt">
                                    {{ formatNumber(amt) }}
                                </button>
                                <button class="exact" @click="Items.jsonotherdonne.montantrecu = Items.mtnt.docmtnttotalttc">
                                    Exact
                                </button>
                            </div>
                        </div>

                        <!-- Validate Button -->
                        <button
                                class="validate-btn"
                                @click="validateSale"
                                :disabled="!canValidate || compteprocess > 0"
                        >
                            <template v-if="compteprocess > 0">
                                <span class="spinner-small"></span>
                                Traitement... ({{ compteprocess }})
                            </template>
                            <template v-else>
                                <i class="ri-check-double-line"></i>
                                Valider la vente
                                <kbd>F12</kbd>
                            </template>
                        </button>
                    </div>
                </div>
            </section>

            <!-- RIGHT PANEL: Quick Actions & Settings -->
            <aside class="panel-right">


                <!-- Quick Actions -->
                <section class="quick-actions-section">

                    <button @click="newinvoice">
                        <i class="ri-file-add-line"></i>
                        <span>Nouvelle</span>
                        <kbd>F5</kbd>
                    </button>
                    <button @click="openClientSelection">
                        <i class="ri-user-add-line"></i>
                        <span>Client</span>
                        <kbd>F3</kbd>
                    </button>
                    <button @click="openPaymentSelection">
                        <i class="ri-"></i>
                        <span>Mode de règlement</span>
                        <kbd>F4</kbd>
                    </button>
                    <button @click="focusBarcode">
                        <i class="ri-focus-3-line"></i>
                        <span>Scanner</span>
                        <kbd>F2</kbd>
                    </button>
                    <!--button @click="note" :disabled="!listedatatable.length">
                        <i class="ri-printer-line"></i>
                        <span>Note</span>
                        <kbd>F6</kbd>
                    </button-->
                    <button @click="Misecommandeenattente" :disabled="!listedatatable.length">
                        <i class="ri-pause-circle-line"></i>
                        <span>Attente</span>
                        <kbd>F7</kbd>
                    </button>

                </section>

                <!-- Numpad -->
                <section class="numpad-section">
                    <div class="numpad-display">{{ numpadDisplay || '0' }}</div>
                    <div class="numpad-grid">
                        <button v-for="key in ['7','8','9','4','5','6','1','2','3','C','0','⌫']" :key="key" @click="handleNumpad(key)" :class="{ action: key === 'C' || key === '⌫' }">
                            {{ key }}
                        </button>
                    </div>
                    <div class="numpad-actions">
                        <button @click="applyNumpadToQty">→ Qté</button>
                        <button @click="applyNumpadToPayment">→ Paiement</button>
                    </div>
                </section>

                <!-- Settings -->
                <section class="settings-section hidden">
                    <div class="setting-row">
                        <span>Conserver données</span>
                        <label class="switch">
                            <input type="checkbox" v-model="conservationdesdonnees" />
                            <span class="slider"></span>
                        </label>
                    </div>
                    <div class="setting-row">
                        <span>Mode normalisation</span>
                        <label class="switch">
                            <input type="checkbox" v-model="isNormalisationEtat" :disabled="listedatatable.length > 0" />
                            <span class="slider"></span>
                        </label>
                    </div>
                </section>
            </aside>
        </main>



        <!-- ==================== FLOATING ACTION BUTTONS ==================== -->
        <div class="fab-container">
            <!-- Main FAB -->
            <button class="fab-main" @click="toggleFabMenu" :class="{ active: fabMenuOpen }">
                <i class="ri-add-line" v-if="!fabMenuOpen"></i>
                <i class="ri-close-line" v-else></i>
            </button>

            <!-- FAB Menu -->
            <transition-group name="fab-item">
                <button v-if="fabMenuOpen" class="fab-item client" @click="openClientSelection">
                    <i class="ri-user-add-line"></i>
                    <span class="fab-label">Client</span>
                </button>

                <button v-if="fabMenuOpen" class="fab-item payment" @click="openPaymentSelection">
                    <i class="ri-money-euro-circle-line"></i>
                    <span class="fab-label">Paiement</span>
                </button>

                <button v-if="fabMenuOpen" class="fab-item options" @click="openOptions">
                    <i class="ri-settings-3-line"></i>
                    <span class="fab-label">Options</span>
                </button>

                <button v-if="fabMenuOpen" class="fab-item quick-note" @click="note" :disabled="!listedatatable.length">
                    <i class="ri-printer-line"></i>
                    <span class="fab-label">Note</span>
                </button>
            </transition-group>
        </div>




        <!-- ==================== MODALS ==================== -->
        <!-- Modal pour sélection client -->
        <div v-if="showClientModal" class="modal-overlay" @click="showClientModal = false">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h3>Sélection du client</h3>
                    <button @click="showClientModal = false" class="modal-close">
                        <i class="ri-close-line"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="client-modal-form">
                        <div class="form-field">
                            <label>Client</label>
                            <select v-model="Items.jsonotherdonne.cltfrs" @change="handleClientSelect">
                                <option :value="null">-- Sélectionner --</option>
                                <option v-for="(c, i) in otherdatatable.beneficiairecl" :key="i" :value="c">
                                    {{ c.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-field">
                            <label>IFU</label>
                            <input v-model="Items.jsonv.ifu" placeholder="IFU" />
                        </div>
                        <div class="form-field">
                            <label>Nom client</label>
                            <input v-model="Items.jsonv.client" placeholder="Nom client" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal pour sélection paiement -->
        <div v-if="showPaymentModal" class="modal-overlay" @click="showPaymentModal = false">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h3>Mode de règlement</h3>
                    <button @click="showPaymentModal = false" class="modal-close">
                        <i class="ri-close-line"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="payment-methods">
                        <button
                                v-for="(m, i) in otherdatatable.modedereglement"
                                :key="i"
                                @click="selectPaymentMethod(m)"
                                class="payment-method"
                                :class="{ selected: Items.jsonv.modereglement?.name === m.name }"
                        >
                            <i class="ri-bank-card-line"></i>
                            <span>{{ m.name }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal options -->
        <div v-if="showOptionsModal" class="modal-overlay" @click="showOptionsModal = false">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h3>Options</h3>
                    <button @click="showOptionsModal = false" class="modal-close">
                        <i class="ri-close-line"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="options-list">
                        <button @click="handlebtnreinitialiserAllarticle(); showOptionsModal = false" class="option-item">
                            <i class="ri-refresh-line"></i>
                            <span>Synchroniser articles</span>
                        </button>
                        <button @click="btnmodalrecapitulatifca(); showOptionsModal = false" class="option-item">
                            <i class="ri-bar-chart-box-line"></i>
                            <span>Analyse CA</span>
                        </button>
                        <button @click="toggleTheme(); showOptionsModal = false" class="option-item">
                            <i :class="isDarkMode ? 'ri-sun-line' : 'ri-moon-line'"></i>
                            <span>Changer thème</span>
                        </button>

                        <button @click="resetConfig(); showOptionsModal = false" class="option-item">
                            <i class="ri-delete-row"></i>
                            <span>Réinitialiser la configuration d'impression</span>
                        </button>


                    </div>
                </div>
            </div>
        </div>





        <!-- ==================== FOOTER SHORTCUTS ==================== -->
        <footer class="app-footer">
            <div class="shortcut"><kbd>F2</kbd> Scanner</div>
            <div class="shortcut"><kbd>F3</kbd> Client</div>
            <div class="shortcut"><kbd>F4</kbd> Mode de règlement</div>
            <div class="shortcut"><kbd>F5</kbd> Nouvelle</div>
            <div class="shortcut"><kbd>F6</kbd> Note</div>
            <div class="shortcut"><kbd>F7</kbd> Attente</div>
            <div class="shortcut"><kbd>F12</kbd> Valider</div>
            <div class="shortcut"><kbd>Échap</kbd> Annuler</div>
        </footer>


    </div>

    <!-- ==================== MODALS ==================== -->
    <modalviewitemsdetails ref="modalviewitemsdetails"></modalviewitemsdetails>
    <modalmodifierquantite ref="modalmodifierquantite" @updateqteitem="updateqteitem"></modalmodifierquantite>
    <modalfactureenattente ref="modalfactureenattente" @selectedfacture="updatefactureselected"></modalfactureenattente>
    <modalfacturecomptoirepost ref="modalfacturecomptoirepost" @closed="closeimpression"></modalfacturecomptoirepost>
    <modalpointdelacaisse5 ref="modalpointdelacaisse5"></modalpointdelacaisse5>
    <moadalindextransfertdefonddecaisse ref="moadalindextransfertdefonddecaisse" @closed="handleloadsoldecaisse"></moadalindextransfertdefonddecaisse>
    <fermerturecaisseouinon ref="fermerturecaisseouinon"></fermerturecaisseouinon>
    <modalrecapitulatifca ref="modalrecapitulatifca"></modalrecapitulatifca>
    <modalrapportdecaisse5 ref="modalrapportdecaisse5"></modalrapportdecaisse5>
    <modalrapportdecaisse6 ref="modalrapportdecaisse6"></modalrapportdecaisse6>
  <modallistedesfacturactionsalacaisse ref="modallistedesfacturactionsalacaisse"></modallistedesfacturactionsalacaisse>
</template>

<script>
    import { inject } from 'vue';
    import modalfacturecomptoirepost from "@/components/views/pages/caisse/rapport/modal_facturecomptoirepost";
    import modalpointdelacaisse5 from "@/components/views/pages/caisse/facturation/5/rapport/modal_listedesfacturactionsalacaisse_5";
    import moadalindextransfertdefonddecaisse from "@/components/views/pages/caisse/transfertdefonddecaisse/index";
    import modalmodifierquantite from "@/components/views/pages/caisse/facturation/modal_modifierquantite";
    import modalviewitemsdetails from "@/components/views/pages/caisse/facturation/modal_viewitemsdetails";
    import modalfactureenattente from "@/components/views/pages/caisse/facturation/5/modal_factureenattente";
    import modalrapportdecaisse5 from "@/components/views/pages/caisse/facturation/5/rapport/modal_rapportdecaisse_5";
    import modalrapportdecaisse6 from "@/components/views/pages/caisse/facturation/5/rapport/modal_rapportdecaisse_6v2.vue";
    import fermerturecaisseouinon from "@/components/views/pages/caisse/fermerturecaisseouinon";
    import modalrecapitulatifca from "@/components/views/pages/caisse/rapport/modal_recapitulatifCA";

    const axios = require('axios');
    import {
        array_search,
        cloneobjet,
        currencyFormatDE,
        FormatNumber,
        groupByKey,
        isset,
        issetObject,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import { mapGetters } from "vuex";
    import qrcodetoimage from "qrcode";
    import modallistedesfacturactionsalacaisse
      from "@/components/views/pages/caisse/rapport/modal_listedesfacturactionsalacaissev2.vue";

    export default {
        /* eslint-disable */
        name: "CaisseFacturationV2",

        components: {
          modallistedesfacturactionsalacaisse,
            modalmodifierquantite,
            modalfactureenattente,
            modalfacturecomptoirepost,
            modalpointdelacaisse5,
            modalviewitemsdetails,
            moadalindextransfertdefonddecaisse,
            fermerturecaisseouinon,
            modalrapportdecaisse5,
          modalrapportdecaisse6,
            modalrecapitulatifca,
        },

        data() {
            return {
                // UI State
                isDarkMode: true,
                showDropdown: false,
                showArticleList: false,
                showClientForm: true,
                scanActive: false,

                showClientPanel: false,

                // Floating Action Buttons
                fabMenuOpen: false,
                showClientModal: false,
                showPaymentModal: false,
                showOptionsModal: false,



                // Pre-scan quantity
                prescanQty: 1,

                // Numpad
                numpadDisplay: '',

                // Data
                conservationdesdonnees: true,
                datatable: [],
                otherdatatable: {},
                datatablearticle: [],
                listedatatable: [],
                selectedArticle: null,

                // Messages
                messageerror: "",
                messagesucces: "",
                compteprocess: 0,

                // Filters
                selectedcatalogue: "",
                searchword: "",
                lecteurdecodebarre: "",

                // Pagination
                page: 1,
                perPage: 20,
                DefaultperPage: 20,
                pages: [],

                // Article being added
                ItemsArticle: {
                    accompagnement: [],
                    autredesignation: '',
                    mycheckkey: '',
                    docnum: '',
                    article: null,
                    qtite: 0,
                    diqte: 0,
                    pu: 0,
                    pa: 0,
                    mtnt: 0,
                    mtntclt: 0,
                    remise: 0,
                    doc: '',
                    docpid: '',
                    docnumother: '',
                    docmag: '',
                    doctp: '',
                    linekey: '',
                    calmtntht: 0,
                    etatline: 0,
                    pid: ''
                },

                // Document
                Items: {},

                // Normalization
                isNormalisationEtat: false,
            };
        },

        computed: {
            ...mapGetters(['listedesarticlespourlacaisse', 'myscreenSize']),

            viewclientBloc() {
                return issetObject(this.Items.jsonotherdonne);
            },

            datatablearticlegroupe() {
                this.datatablearticle = cloneobjet(this.listedesarticlespourlacaisse);
                return groupByKey(this.listedesarticlespourlacaisse, 'catalogue');
            },

            nbrefactureenattante() {
                return this.datatable.length;
            },

            filterdatatable() {
                let mvalue = [];
                this.perPage = this.DefaultperPage;

                // Get all articles from groups
                for (let [index, datavalue] of Object.entries(this.datatablearticlegroupe)) {
                    if (this.selectedcatalogue === '' || index.toLowerCase() === this.selectedcatalogue.toLowerCase()) {
                        mvalue.push(...datavalue);
                    }
                }

                // Filter by search
                if (this.searchword) {
                    const searchLower = this.searchword.toLowerCase();
                    mvalue = mvalue.filter(a =>
                        a.libelle.toLowerCase().includes(searchLower) ||
                        (a.codebarre && a.codebarre.includes(this.searchword)) ||
                        (a.reference && a.reference.toLowerCase().includes(searchLower))
                    );
                }

                return this.paginate(mvalue);
            },

            reliquat() {
                const val = parseFloat(this.Items.jsonotherdonne?.montantrecu || 0) - parseFloat(this.Items.mtnt?.docmtnttotalttc || 0);
                return currencyFormatDE(val);
            },

            reliquatValue() {
                return parseFloat(this.Items.jsonotherdonne?.montantrecu || 0) - parseFloat(this.Items.mtnt?.docmtnttotalttc || 0);
            },

            canValidate() {
                if (!this.listedatatable.length) return false;
                if ((this.Items.mtnt?.doccalmtnttotalht || 0) <= 0) return false;
                const pendingItems = this.listedatatable.filter(item => item.etatline === 0);
                return pendingItems.length === 0;
            }
        },

        watch: {
            searchword() {
                this.page = 1;
            },
            prescanQty(val) {
                if (val < 1) this.prescanQty = 1;
            }
        },

        methods: {


          btnmodallistedesfacturactionsalacaisse(value){

            let titlemodal="",numpidcaisse="",datedouverture=""

            if (value==='FVC'){titlemodal="LISTE DES FACTURATIONS AU COMPTOIRE"}



            if (Object.keys(this.$store.state.caisseinfo).length>0){

              numpidcaisse=this.$store.state.caisseinfo.cpid,
                  datedouverture=this.$store.state.caisseinfo.dateouverture

            }
            else{


              numpidcaisse=this.$store.state.caisseencour,
                  datedouverture=""


            }

            this.$refs.modallistedesfacturactionsalacaisse.show(titlemodal,numpidcaisse,datedouverture,value);
          },






          resetConfig() {
                if (confirm('Êtes-vous sûr de vouloir réinitialiser la configuration ?')) {
                    /*this.resetToDefaults();*/
                    this.$refs.modalfacturecomptoirepost.resetToDefaults('note');
                    this.$refs.modalfacturecomptoirepost.resetToDefaults('facture');
                    toastr['success']('Configuration réinitialisée avec succès') ||
                    alert('Configuration réinitialisée avec succès');
                }
            },


            // ============ UI Methods ============
            toggleMenu() {
                this.showDropdown = !this.showDropdown;
            },

            toggleTheme() {
                if (this.listedatatable.length > 0) return;
                this.isDarkMode = !this.isDarkMode;
                this.isNormalisationEtat = !this.isDarkMode;
                if (this.Items.jsonv) {
                    this.Items.jsonv.isnormalisationetat = this.isNormalisationEtat;
                }
            },

            focusBarcode() {
                this.$refs.barcodeInput?.focus();
            },

            focusPayment() {
                this.$refs.paymentInput?.focus();
            },


            // ============ FAB Methods ============
            toggleFabMenu() {
                this.fabMenuOpen = !this.fabMenuOpen;
            },

            openClientSelection() {
                this.showClientModal = true;
                this.fabMenuOpen = false;
            },

            openPaymentSelection() {
                this.showPaymentModal = true;
                this.fabMenuOpen = false;
            },

            openOptions() {
                this.showOptionsModal = true;
                this.fabMenuOpen = false;
            },

            selectPaymentMethod(method) {


                this.Items.jsonv.modereglement = method;
              this.Items.jsonotherdonne.moderglt = method;
                this.showPaymentModal = false;
            },

            // ============ Numpad ============
            handleNumpad(key) {
                if (key === 'C') {
                    this.numpadDisplay = '';
                } else if (key === '⌫') {
                    this.numpadDisplay = this.numpadDisplay.slice(0, -1);
                } else {
                    this.numpadDisplay += key;
                }
            },

            applyNumpadToQty() {
                const val = parseInt(this.numpadDisplay) || 1;
                this.prescanQty = val;
                this.numpadDisplay = '';
                this.focusBarcode();
            },

            applyNumpadToPayment() {
                const val = parseFloat(this.numpadDisplay) || 0;
                this.Items.jsonotherdonne.montantrecu = val;
                this.numpadDisplay = '';
            },

            // ============ Barcode Scan ============
            handleBarcodeScan() {
                if (!this.lecteurdecodebarre) {
                    toastr['error']("Code-barres vide");
                    return;
                }

                this.scanActive = true;

                const code = this.lecteurdecodebarre.trim();
                const found = this.datatablearticle.find(a => a.codebarre === code);

                if (found) {
                    this.addArticleToCart(found, this.prescanQty);
                    this.prescanQty = 1; // Reset after scan
                } else {
                    toastr['error']("Article non trouvé");
                }

                this.lecteurdecodebarre = "";

                setTimeout(() => {
                    this.scanActive = false;
                }, 300);
            },

            // ============ Article Selection ============
            selectArticle(article) {
                this.selectedArticle = article;
            },

            quickAddToCart(article) {
                this.addArticleToCart(article, this.prescanQty);
                this.prescanQty = 1;
            },

            openQuantityModal(article) {
                this.Items.jsonotherdonne.moderglt = this.Items.jsonv.modereglement;
                const itemData = {
                    ...this.ItemsArticle,
                    article: article,
                    mycheckkey: article.pid,
                    qtite: this.prescanQty,
                    pu: this.isNormalisationEtat ? article.pu7 : article.pu
                };
                this.$refs.modalmodifierquantite.show(cloneobjet(itemData), this.isNormalisationEtat, 'add');
                this.prescanQty = 1;
            },

            addArticleToCart(article, qty) {
                // Validate
                this.Items.jsonotherdonne.moderglt = this.Items.jsonv.modereglement;

                if (!this.Items.jsonotherdonne.cltfrs) {
                    toastr['error']('Sélectionnez un client');
                    return;
                }

                if (!this.Items.jsonv.client) {
                    this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
                    this.Items.jsonv.ifu = this.Items.jsonotherdonne.cltfrs.ifu;
                }

               /* if (!this.Items.jsonotherdonne.moderglt) {
                    toastr['error']('Sélectionnez le mode de règlement');
                    return;
                }*/

                const mycheckkey = article.pid;
                const existing = this.findExistingItem(mycheckkey);

                if (existing) {
                    // Update existing
                    existing.qtite = parseFloat(existing.qtite) + qty;
                    const pu = this.isNormalisationEtat ? article.pu7 : article.pu;
                    existing.mtnt = parseFloat(pu) * existing.qtite;
                    existing.calmtntht = existing.mtnt - parseFloat(existing.remise || 0);
                    this.ItemsArticle = existing;
                    this.SaveArticle();
                } else {
                    // New item
                    const pu = this.isNormalisationEtat ? article.pu7 : article.pu;
                    const mtnt = parseFloat(pu) * qty;

                    this.ItemsArticle = {
                        article,
                        mycheckkey,
                        qtite: qty,
                        diqte: 0,
                        pu: parseFloat(pu),
                        pa: parseFloat(article.pa),
                        mtnt,
                        mtntclt: mtnt,
                        calmtntht: mtnt,
                        docnumother: '',
                        remise: 0,
                        doctp: 'F',
                        pid: "",
                        docpid: this.Items.docpid,
                        docnum: this.Items.docpid,
                        autredesignation: "",
                        linekey: "",
                        etatline: 0,
                        accompagnement: [],
                    };

                    this.SaveArticle();
                }
            },

            findExistingItem(mycheckkey) {
                const found = this.listedatatable.find(a => a.mycheckkey === mycheckkey);
                if (!found) return null;

                return {
                    linekey: found.linekey,
                    etatline: found.etatline,
                    calmtntht: found.calmtntht,
                    accompagnement: found.accompagnement,
                    mycheckkey: found.mycheckkey,
                    article: found.article,
                    qtite: found.qtite,
                    diqte: 0,
                    pu: found.ppu,
                    pa: found.pa,
                    mtnt: found.mtnt,
                    docnumother: "",
                    remise: found.remise,
                    autredesignation: found.autredesignation,
                    doctp: found.doctyp,
                    pid: found.pid,
                    docpid: found.docnum,
                    docnum: found.docnum
                };
            },

            getItemStatusClass(item) {
                if (item.etatline == 1) return 'status-success';
                if (item.etatline == 2) return 'status-error';
                return 'status-pending';
            },

            // ============ Client Handling ============
            handleClientSelect() {
                if (this.Items.jsonotherdonne.cltfrs) {
                    this.Items.jsonv.client = this.Items.jsonotherdonne.cltfrs.name;
                    this.Items.jsonv.ifu = this.Items.jsonotherdonne.cltfrs.ifu;
                } else {
                    this.Items.jsonv.client = '';
                    this.Items.jsonv.ifu = '';
                }
            },

            // ============ Formatting ============
            formatNumber(num) {
                return currencyFormatDE(Number(num));
            },

            formatNumber2(num) {
                return FormatNumber(Number(num));
            },

            currencyFormatDE(num) {
                return currencyFormatDE(Number(num));
            },

            calculSomme(p1, p2, p3) {
                return currencyFormatDE(parseFloat(p1) + parseFloat(p2) + parseFloat(p3));
            },

            calculMonnaie(p1, p2) {
                return currencyFormatDE(parseFloat(p2) - parseFloat(p1));
            },

            // ============ Modal Methods ============
            btnmoadalfermercaisse() {
                this.$refs.fermerturecaisseouinon.show();
            },

            btnmoadalindextransfertdefonddecaisse(typedoc, vtypc) {
                this.$refs.moadalindextransfertdefonddecaisse.show(null, typedoc, vtypc);
            },

            btnmodalrecapitulatifca() {
                const numpidcaisse = this.$store.state.caisseinfo?.cpid || this.$store.state.caisseencour;
                const datedouverture = this.$store.state.caisseinfo?.dateouverture || "";
                this.$refs.modalrecapitulatifca.show("Analyse du chiffre d'affaires", numpidcaisse, datedouverture);
            },

            btnmodalpointdelacaisse5() {
                const numpidcaisse = this.$store.state.caisseinfo?.cpid || this.$store.state.caisseencour;
                const datedouverture = this.$store.state.caisseinfo?.dateouverture || "";
                this.$refs.modalrapportdecaisse5.show("RAPPORT DE CAISSE", numpidcaisse, datedouverture, 'FVC', this.isNormalisationEtat);
            },

            btnmodalpointdelacaisse6() {
                const numpidcaisse = this.$store.state.caisseinfo?.cpid || this.$store.state.caisseencour;
                const datedouverture = this.$store.state.caisseinfo?.dateouverture || "";
                this.$refs.modalrapportdecaisse6.show("ANALYSE DE CAISSE", numpidcaisse, datedouverture, 'FVC', this.isNormalisationEtat);
            },

            btnupdatefactureselected() {
                this.$refs.modalfactureenattente.show(this.datatable);
            },

            btnupdateqteitem(datavalue) {
                this.$refs.modalmodifierquantite.show(cloneobjet(datavalue), this.isNormalisationEtat, 'update');
            },

            updateqteitem(data) {
                this.ItemsArticle = data.item;
                this.SaveArticle();
            },

            async updatefactureselected(data) {
                const value = data.item;
                this.Items = value;
                this.isNormalisationEtat = this.Items.jsonv.isnormalisationetat;

                this.$store.dispatch('lancerchargement', true);

                try {
                    const url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/${value.pid}/${this.$store.state.appsociete}/allline895418init51comptoirerefdepdpcc11515/option2/${randomString(280)}`;
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.Items.jsonotherdonne.montantrecu = 0;
                        this.Items.docnum = value.numdoc;
                        this.Items.docpid = value.pid;
                        this.Items.pid = value.pid;
                        this.ItemsArticle.docnum = value.pid;
                        this.ItemsArticle.docpid = value.pid;
                        this.listedatatable = response.data.m;
                        this.calcullistedatatable();
                        this.Items.jsonotherdonne.mtypprixdevente = 'prixvente';
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            note() {
                if (!this.listedatatable.length) return;

                const items = this.listedatatable.filter(line => line.etatline !== 2);
                const tabvalue = {
                    numdoc: this.Items.docnum,
                    date: this.Items.datedoc,
                    client: this.Items.jsonv.client,
                    ifu: this.Items.jsonv.ifu,
                    params: this.Items.jsonv.param?.name || '',
                    params4: '',
                    boutique: '',
                    serveur: this.Items.jsonv.collaborateur?.name || '',
                    commandetable: this.Items.jsonv.commandetable?.name || '',
                    vendeur: this.$store.state.appusername,
                    items,
                    montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
                    montanttva: 0,
                    montantremise: this.currencyFormatDE(this.Items.mtnt.docmtntremise),
                    montantnetapayer: this.Items.mtnt.docmtnttotalttc,
                    reglement: this.Items.jsonotherdonne.montantrecu,
                    montantmonnaie: 0,
                    pourcentageprisenecharge: 0,
                    docsaisiepar: this.$store.state.appusername,
                    normalise: '',
                    mecefsignature: '',
                    mecefnim: '',
                    mecefcompteur: '',
                    mecefheure: '',
                    mecefqrr: "",
                };

                this.$refs.modalfacturecomptoirepost.show(tabvalue, 'note');
            },

            closeimpression(element) {
                if (element !== 'note' && element === 'facture') {
                    this.newinvoice();
                    this.load();
                }
            },

            // ============ Cart Calculations ============
            calcullistedatatable() {
                let montantnontaxable = 0,
                    montantaib = 0,
                    montanttva = 0,
                    montanthtarpvht = 0,
                    montanthtarpvttc = 0,
                    montanttotalht = 0,
                    montanttotalttc = 0,
                    smontantremise = 0,
                    istva = 0;

                if (this.listedatatable.length > 0) {
                    this.listedatatable.forEach(line => {
                        if ([0, 1, 4, '0', '1', '4'].includes(line.etatline)) {
                            const datajsonarticle = line.article;
                            const lignemontantht = line.mtnt;
                            const mtnt_remise = line.remise;

                            if (datajsonarticle.taxedimposition !== "A") {
                                if (this.Items.jsonotherdonne.appliquetva == 1) {
                                    istva = 1;
                                    if (parseFloat(datajsonarticle.tptva) === 1) {
                                        montanthtarpvttc += parseFloat(lignemontantht);
                                    } else {
                                        montanthtarpvht += parseFloat(lignemontantht);
                                    }
                                } else {
                                    montanthtarpvht += parseFloat(lignemontantht);
                                }
                            } else {
                                montantnontaxable += parseFloat(lignemontantht);
                            }

                            smontantremise += parseFloat(mtnt_remise);
                        }
                    });

                    montanttotalht = montanthtarpvttc + montanthtarpvht + montantnontaxable;

                    if (istva === 1) {
                        montanttva = montanthtarpvttc * 0.18;
                    }

                    const aib = parseInt(this.Items.jsonotherdonne.aib) || 0;
                    let libaib = "AIB";

                    if (aib !== 0) {
                        libaib = `Montant AIB (${aib} %)`;
                        montantaib = montanttotalht * (aib / 100);
                    }

                    montanttotalttc = montanttotalht + montantaib + montanttva;

                    this.Items.mtnt = {
                        doctva: Math.round(montanttva),
                        docmtnttotalttc: Math.round(montanttotalttc),
                        docmtntaib: Math.round(montantaib),
                        docmtntremise: Math.round(smontantremise),
                        docmtnttotalht: Math.round(montanttotalht),
                        doccalmtnttotalht: Math.round(montanttotalht) + Math.round(smontantremise),
                        libaib
                    };
                } else {
                    this.Items.mtnt = {
                        doctva: 0,
                        docmtnttotalttc: 0,
                        docmtntaib: 0,
                        docmtntremise: 0,
                        docmtnttotalht: 0,
                        doccalmtnttotalht: 0,
                        libaib: "Montant AIB (0 %)"
                    };
                }
            },

            newArticle() {
                this.ItemsArticle = {
                    accompagnement: [],
                    autredesignation: '',
                    mycheckkey: '',
                    docnum: '',
                    article: null,
                    qtite: 0,
                    diqte: 0,
                    pu: 0,
                    pa: 0,
                    mtnt: 0,
                    mtntclt: 0,
                    remise: 0,
                    doc: '',
                    docpid: '',
                    docnumother: '',
                    docmag: '',
                    doctp: '',
                    linekey: '',
                    calmtntht: 0,
                    etatline: 0,
                    pid: ''
                };
            },

            // ============ Save Article ============
            async SaveArticle_old() {
                this.searchword = "";

                if (!this.Items.jsonotherdonne.cltfrs) {
                    toastr['error']('Sélectionnez un client');
                    return;
                }

                if (!this.Items.jsonotherdonne.moderglt) {
                    toastr['error']('Sélectionnez le mode de règlement');
                    return;
                }

                if (!this.ItemsArticle.article) {
                    toastr['error']('Sélectionnez un article');
                    return;
                }

                if (parseFloat(this.ItemsArticle.qtite) === 0 || parseFloat(this.ItemsArticle.mtnt) === 0 || parseFloat(this.ItemsArticle.pu) === 0) {
                    toastr['error']('Informations incomplètes');
                    return;
                }

                let linekey = "";
                let mitems;

                if (this.ItemsArticle.linekey === "") {
                    linekey = randomString(20);
                    this.ItemsArticle.linekey = linekey;
                    this.ItemsArticle.etatline = 0;
                    this.ItemsArticle.ppu = this.ItemsArticle.pu;
                    this.ItemsArticle.calmtntht = parseFloat(this.ItemsArticle.remise) + parseFloat(this.ItemsArticle.mtnt);

                    mitems = cloneobjet(this.ItemsArticle);
                    this.listedatatable.push(mitems);
                }
                else {
                    linekey = this.ItemsArticle.linekey;
                    const newqtite = this.ItemsArticle.qtite;

                    this.listedatatable.forEach(line => {
                        if (line.linekey === linekey) {
                            line.etatline = 0;
                            line.qtite = newqtite;
                            line.ppu = this.ItemsArticle.pu;
                            line.pu = this.ItemsArticle.pu;
                            line.autredesignation = this.ItemsArticle.autredesignation;
                            line.mtnt = this.ItemsArticle.mtnt;
                            line.mtntclt = this.ItemsArticle.mtntclt;
                            line.remise = this.ItemsArticle.remise;
                            line.calmtntht = parseFloat(this.ItemsArticle.remise) + parseFloat(this.ItemsArticle.mtnt);
                        }
                    });

                    mitems = cloneobjet(this.ItemsArticle);
                }

                this.newArticle();
                this.calcullistedatatable();
                this.compteprocess++;

                mitems.cf = this.$store.state.caisseinfo;

                try {
                    let url, response;

                    if (this.Items.pid !== "") {
                        url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/${this.$store.state.caisseencour}/${this.$store.state.appsociete}/vline895418init51comptoirerefdepdpcc11515/option2/${randomString(280)}`;
                        response = await axios.post(url, mitems, {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                                'csrftoken': this.$store.state.appsociete
                            },
                            withCredentials: true
                        });
                    } else {
                        this.$store.dispatch('lancerchargement', true);

                        this.Items.jsonotherdonne.tpdoc = "facture";
                        this.Items.jsonotherdonne.tredocument = "vente";
                        this.Items.cf = this.$store.state.caisseinfo;
                        this.Items.jsonv.modereglement = this.Items.jsonotherdonne.moderglt;
                        this.Items.jsonv.typ = "VENC";
                        this.Items.jsonv.comptabilise = 0;

                        const donneval = { 'itemdoc': this.Items, 'itemArticle': mitems };

                        url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/${this.$store.state.caisseencour}/${this.$store.state.appsociete}/add895418init51comptoirerefdepdpcc11515/option2/${randomString(280)}`;
                        response = await axios.post(url, donneval, {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                                'csrftoken': this.$store.state.appsociete
                            },
                            withCredentials: true
                        });
                    }

                    if (response.data.success) {
                        toastr['success'](response.data.message);
                        this.compteprocess--;

                        if (this.Items.pid === "") {
                            this.Items.docnum = response.data.numdoc;
                            this.Items.docpid = response.data.keypid;
                            this.Items.pid = response.data.keypid;
                            this.ItemsArticle.docnum = response.data.keypid;
                            this.ItemsArticle.docpid = response.data.keypid;
                        }

                        let searchPid = "";
                        this.listedatatable.forEach(line => {
                            if (line.linekey === linekey) {
                                line.etatline = 1;
                                searchPid = line.article.pid;
                                if (line.pid === "") {
                                    line.pid = response.data.keyline;
                                    line.docnum = response.data.keypid;
                                    line.docpid = response.data.keypid;
                                }
                            }
                        });

                        const checkindex = array_search(searchPid, this.datatablearticle, 'pid');
                        if (checkindex >= 0 && parseFloat(this.datatablearticle[checkindex].instock) === 1) {
                            this.datatablearticle[checkindex].rstck = response.data.pk;
                            this.$store.commit('listedesarticlespourlacaisse', { value: this.datatablearticle });
                        }
                    } else {
                        toastr['error'](response.data.message);
                        this.compteprocess--;

                        this.listedatatable.forEach(line => {
                            if (line.linekey === linekey) {
                                line.etatline = 2;
                                line.linemessage = `Erreur: ${response.data.message}`;
                            }
                        });

                        this.calcullistedatatable();
                    }
                } catch (error) {
                    toastr['error']("Erreur de traitement");
                    this.compteprocess--;

                    this.listedatatable.forEach(line => {
                        if (line.linekey === linekey) {
                            line.etatline = 2;
                            line.linemessage = "Erreur. Veuillez réessayer.";
                        }
                    });

                    this.calcullistedatatable();
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }

                // Scroll to bottom
                this.$nextTick(() => {
                    const scroll = this.$refs.cartScroll;
                    if (scroll) scroll.scrollTop = scroll.scrollHeight;
                });
            },

            // ============ Delete Article ============
            async deleteItemArticle_old(ItemsArticle) {
                if (!ItemsArticle.article) {
                    toastr['error']('Article invalide');
                    return;
                }

                const linekey = ItemsArticle.linekey;

                if (ItemsArticle.pid === "") {
                    const index = this.listedatatable.findIndex(line => line.linekey === linekey);
                    if (index > -1) {
                        this.listedatatable.splice(index, 1);
                    }
                    this.newArticle();
                    this.calcullistedatatable();
                    return;
                }

                this.listedatatable.forEach(line => {
                    if (line.linekey === linekey) {
                        line.etatline = 0;
                    }
                });

                this.newArticle();
                this.calcullistedatatable();
                this.compteprocess++;

                const mitems = cloneobjet(ItemsArticle);
                mitems.spid = ItemsArticle.docnum;

                try {
                    const url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/${this.$store.state.caisseencour}/${this.$store.state.appsociete}/svline895418init51comptoirerefdepdpcc11515/option2/${randomString(280)}`;
                    const response = await axios.post(url, mitems, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        toastr['success'](response.data.message);
                        this.compteprocess--;

                        let searchPid = "";
                        const index = this.listedatatable.findIndex(line => line.linekey === linekey);
                        if (index > -1) {
                            searchPid = this.listedatatable[index].article.pid;
                            this.listedatatable.splice(index, 1);
                        }

                        this.calcullistedatatable();

                        const checkindex = array_search(searchPid, this.datatablearticle, 'pid');
                        if (checkindex >= 0 && parseFloat(this.datatablearticle[checkindex].instock) === 1) {
                            this.datatablearticle[checkindex].rstck = response.data.pk;
                            this.$store.commit('listedesarticlespourlacaisse', { value: this.datatablearticle });
                        }
                    } else {
                        toastr['error'](response.data.message);
                        this.compteprocess--;

                        this.listedatatable.forEach(line => {
                            if (line.linekey === linekey) {
                                line.etatline = 2;
                                line.linemessage = `Erreur: ${response.data.message}`;
                            }
                        });
                    }
                } catch (error) {
                    toastr['error']("Erreur de suppression");
                    this.compteprocess--;

                    this.listedatatable.forEach(line => {
                        if (line.linekey === linekey) {
                            line.etatline = 2;
                            line.linemessage = "Erreur. Veuillez réessayer.";
                        }
                    });
                }
            },

            async SaveArticle(){

                this.searchword="";

                if (this.Items.jsonotherdonne.cltfrs===null ){
                    toastr['error']( 'Veuillez séléctionner un client',"<b></b>");
                    return
                }

               /* if (this.Items.jsonotherdonne.moderglt===null ){
                    toastr['error']( 'Veuillez séléctionner le mode de réglement',"<b></b>");
                    return
                }*/

                if (this.ItemsArticle.article===null)
                {
                    toastr['error']( 'Veuillez sélectionner un article valide',"<b></b>");
                    return

                }

                if (parseFloat(this.ItemsArticle.qtite)===0 ||
                    parseFloat(this.ItemsArticle.mtnt)===0  ||
                    parseFloat(this.ItemsArticle.pu)===0)
                {
                    toastr['error']( 'Veuillez saisir toutes les informations(la quantité ou le prix)',"<b></b>");
                    return

                }




                let vm=this,
                    linekey="",
                    newqtite=0,
                    $mtnt=0,
                    $remise=0,
                    oldqtite=0,
                    mitems,
                    t=this;


                if (t.ItemsArticle.linekey===""){
                    linekey= randomString(20);
                    t.ItemsArticle.linekey=linekey;
                    t.ItemsArticle.etatline=0
                    t.ItemsArticle.ppu=t.ItemsArticle.pu;
                    //t.ItemsArticle.pu=t.ItemsArticle.pu;
                    t.ItemsArticle.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                    mitems=cloneobjet(t.ItemsArticle);

                    t.listedatatable.push(mitems);

                }
                else{

                    linekey=t.ItemsArticle.linekey;
                    newqtite=t.ItemsArticle.qtite;

                    t.listedatatable.forEach(function (line) {

                        if (line.linekey===linekey){
                            line.etatline=0;
                            oldqtite=line.qtite;
                            line.qtite=newqtite;
                            line.ppu=t.ItemsArticle.pu;
                            line.pu=t.ItemsArticle.pu;
                            line.autredesignation=t.ItemsArticle.autredesignation
                            line.mtnt=t.ItemsArticle.mtnt
                            line.mtntclt=t.ItemsArticle.mtntclt
                            line.remise=t.ItemsArticle.remise
                            line.calmtntht=parseFloat(t.ItemsArticle.remise)+parseFloat(t.ItemsArticle.mtnt);

                        }
                    })

                    mitems=cloneobjet(t.ItemsArticle);

                }

                t.newArticle();
                t.calcullistedatatable();
                t.compteprocess++; // compte le de process en cour

               // console.log("t.Items.pid ************* ",t.Items.pid)
                mitems.cf=this.$store.state.caisseinfo;
                mitems.docnum=t.Items.pid;
                mitems.docpid=t.Items.pid;





                let url="",donneval={},response;

                if(t.Items.pid!==""){
                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/vline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,mitems,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }
                else{

                    this.$store.dispatch('lancerchargement',true)


                    t.Items.jsonotherdonne.tpdoc="facture"
                    t.Items.jsonotherdonne.tredocument="vente"
                    t.Items.cf=this.$store.state.caisseinfo
                    t.Items.jsonv.modereglement=t.Items.jsonotherdonne.moderglt
                    t.Items.jsonv.typ="VENC"
                    t.Items.jsonv.comptabilise=0

                    donneval={  'itemdoc':t.Items, 'itemArticle':mitems, }

                    url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/add895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);

                    response =   axios  .post(url,donneval,{
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                    })

                }

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");


                            t.compteprocess--;



                            if(t.Items.pid===""){

                                t.ItemsArticle.docnum=res.data.numdoc;
                                t.Items.docnum=res.data.numdoc;
                                t.Items.docpid=res.data.keypid;
                                t.ItemsArticle.docnum=res.data.keypid;
                                t.ItemsArticle.docpid=res.data.keypid;
                                t.Items.pid=res.data.keypid;

                            }

                            //  if (line.pid===""){line.pid=res.data.key;}

                            let $search=""

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=1;

                                    $search=line.article.pid

                                    if (line.pid===""){

                                        line.pid=res.data.keyline;
                                        line.docnum=res.data.keypid;
                                        line.docpid=res.data.keypid;

                                    }

                                }
                            })

                            let $checkindex=array_search($search,t.datatablearticle,'pid')

                            if ($checkindex>=0){


                                if (parseFloat(t.datatablearticle[$checkindex].instock)===1){
                                    t.datatablearticle[$checkindex].rstck=res.data.pk

                                    t.$store.commit('listedesarticlespourlacaisse', { value:t.datatablearticle });



                                }


                            }





                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                            t.compteprocess--;

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=2;


                                    line.linemessage="Une erreur c'est produite lors du traitement de l'opération." +
                                        " Veuillez réessayer l'opération. "+res.data.message;



                                }

                            })

                            t.calcullistedatatable();



                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");

                        t.compteprocess--;

                        t.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.etatline=2;
                                line.linemessage="Une erreur c'est produite lors du traitement de l'opération.Elle a échoué. Veuillez réessayer l'opération. ";

                            }

                        })

                        t.calcullistedatatable();


                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },

            async deleteItemArticle(ItemsArticle){




                if (ItemsArticle.article===null)
                {

                    toastr['error']( 'Veuillez sélectionner un article valide',"<b></b>");
                    return

                }

                if (parseFloat(ItemsArticle.qtite)===0 ||  parseFloat(ItemsArticle.mtnt)===0  ||  parseFloat(ItemsArticle.pu)===0)
                {

                    toastr['error']( 'Veuillez saisir toutes les informations(la quantité ou le prix)',"<b></b>");
                    return

                }




                ItemsArticle.spid=ItemsArticle.docnum


                const t = this;



                let vm=this,
                    linekey="",
                    newqtite=0,
                    $mtnt=0,
                    $remise=0,
                    oldqtite=0,
                    mitems ;


                if (ItemsArticle.linekey===""){
                    /*linekey= randomString(8);
                    t.ItemsArticle.linekey=linekey;
                    t.ItemsArticle.etatline=0
                    t.ItemsArticle.ppu=(t.typededocument==='vente')?t.ItemsArticle.pu:t.ItemsArticle.pa;
                    t.ItemsArticle.pu=(t.typededocument==='vente')?t.ItemsArticle.pu:t.ItemsArticle.pa;

                    mitems=cloneobjet(t.ItemsArticle);

                    t.listedatatable.push(mitems);*/

                }
                else{

                    linekey=ItemsArticle.linekey;
                    newqtite=ItemsArticle.qtite;

                    t.listedatatable.forEach(function (line) {


                        if (line.linekey===linekey){
                            line.etatline=0;
                            oldqtite=line.qtite;


                        }
                    })

                    mitems=cloneobjet(ItemsArticle);

                }

                if (ItemsArticle.pid===""){ // suppression d'un article non enregistrer dans la base de donnée

                    t.listedatatable.forEach(function (line,index) {

                        if (line.linekey===linekey){

                            t.listedatatable.splice(index,1);
                        }

                    })

                    this.newArticle();
                    this.calcullistedatatable();
                    return
                }


                t.newArticle();
                t.calcullistedatatable();
                t.compteprocess++; // compte le de process en cour

                //this.$store.dispatch('lancerchargement',true)
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/'+this.$store.state.caisseencour+'/'+this.$store.state.appsociete+'/svline895418init51comptoirerefdepdpcc11515/option2/'+randomString(280);
                let response =   axios  .post(url,mitems,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        //  t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){


                            toastr['success']( res.data.message,"<b></b>");
                            let $search=""
                            t.compteprocess--;
                            t.listedatatable.forEach(function (line,index) {

                                if (line.linekey===linekey){

                                    $search=line.article.pid

                                    t.listedatatable.splice(index,1);
                                }
                            })

                            t.calcullistedatatable();

                            let $checkindex=array_search($search,t.datatablearticle,'pid')

                            if ($checkindex>=0){


                                if (parseFloat(t.datatablearticle[$checkindex].instock)===1){
                                    t.datatablearticle[$checkindex].rstck=res.data.pk


                                    t.$store.commit('listedesarticlespourlacaisse', { value:t.datatablearticle });

                                }


                            }





                        }
                        else{


                            toastr['error']( res.data.message,"<b></b>");
                            //  t.$store.dispatch('lancerchargement',false)

                            t.compteprocess--;

                            t.listedatatable.forEach(function (line) {

                                if (line.linekey===linekey){
                                    line.etatline=2;


                                    line.linemessage="Une erreur c'est produite lors du traitement de l'opération." +
                                        " Veuillez réessayer l'opération. "+res.data.message;



                                }

                            })

                            // t.calcullistedatatable();



                        }


                    })
                    .catch(function (error) {
                        toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>");

                        t.compteprocess--;

                        t.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.etatline=2;
                                line.linemessage="Une erreur c'est produite lors du traitement de l'opération.Elle a échoué. Veuillez réessayer l'opération. ";

                            }

                        })

                        //t.calcullistedatatable();


                    })
                    .finally(function () {
                        //this.$store.dispatch('lancerchargement',false);

                        /*this.listedatatable.forEach(function (line) {

                            if (line.linekey===linekey){
                                line.linekey=2;

                            }

                        })*/


                    } )







            },





            // ============ Validate Sale ============
            async validateSale() {

               if (this.Items.jsonotherdonne.moderglt===null ){
                   toastr['error']( 'Veuillez séléctionner le mode de réglement',"<b></b>");
                   return
               }




                if ((this.Items.mtnt?.doccalmtnttotalht || 0) <= 0) {
                    toastr['error']('Opération non valide');
                    return;
                }

                if (this.$store.state.authorizeprix0 === "false" || this.$store.state.authorizeprix0 === false) {
                    if (!this.Items.jsonotherdonne.montantrecu) {
                        toastr['error']('Saisissez le montant reçu');
                        return;
                    }
                }

                if (this.$store.state.authorizefacturactionpartiel === "false" || this.$store.state.authorizefacturactionpartiel === false) {
                    if (this.Items.mtnt.docmtnttotalttc > this.Items.jsonotherdonne.montantrecu) {
                        toastr['error']('Montant insuffisant');
                        return;
                    }
                }

                this.$store.dispatch('lancerchargement', true);

                const value = {
                    'cf': this.$store.state.caisseinfo,
                    'dpid': this.Items.pid,
                    'dmtnt': this.Items.jsonotherdonne.montantrecu,
                    'jsonotherdonne': this.Items.jsonotherdonne,
                    'jsonv': this.Items.jsonv,
                      moderglt: this.Items.jsonotherdonne.moderglt,
                    'document': "FCOMPTOIRE",
                    'item': this.Items,
                    'isNormalisationEtat': this.isNormalisationEtat,
                    'componnent': 5,
                };

                try {

                    const url = `${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/doc/caisse/addfkdfkdozojdj_refdepdpcc/${this.$store.state.appsociete}/add895418init51_refdepdpcc11515/${randomString()}`;
                    const response = await axios.post(url, value, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.handleloadsoldecaisse();
                        this.messagesucces = response.data.message;
                        toastr['success'](this.messagesucces);



                        let normalise = 0, mecefsignature = "", mecefnim = "", mecefcompteur = "",
                            mecefheure = "", mecefqrr = "", urlimagegenerer = "";

                        if (
                            this.$store.state.authorizenormalisation === "true" ||
                            this.$store.state.authorizenormalisation === true
                        ) {

                            if (parseFloat(response.data.m.mecef.normalise)>0){



                                mecefsignature = response.data.m.mecef.mecefsignature;
                                mecefnim = response.data.m.mecef.mecefnim;
                                mecefcompteur = response.data.m.mecef.mecefcompteur;
                                mecefheure = response.data.m.mecef.mecefheure;
                                mecefqrr = response.data.m.mecef.mecefqrr;
                                normalise = response.data.m.mecef.normalise;

                                urlimagegenerer = await new Promise((resolve, reject) => {
                                    qrcodetoimage.toDataURL(mecefqrr, { width: 125, margin: 2 }, (err, url) => {
                                        if (err) reject(err);
                                        else resolve(url);
                                    });
                                });
                            }


                        }


                        const items = this.listedatatable.filter(line => line.etatline !== 2);

                        const tabvalue = {
                            numdoc: this.Items.docnum,
                            date: this.Items.datedoc,
                            client: this.Items.jsonv.client,
                            ifu: this.Items.jsonv.ifu,
                            params: this.Items.jsonv.param?.name || '',
                            params4: '',
                            boutique: '',
                            serveur: this.Items.jsonv.collaborateur?.name || '',
                            commandetable: this.Items.jsonv.commandetable?.name || '',
                            vendeur: this.$store.state.appusername,
                            items,
                            montantht: this.calculSomme(this.Items.mtnt.docmtnttotalht, this.Items.mtnt.docmtntremise, 0),
                            montanttva: 0,
                            montantremise: this.currencyFormatDE(this.Items.mtnt.docmtntremise),
                            montantnetapayer: this.currencyFormatDE(this.Items.mtnt.docmtnttotalttc),
                            reglement: this.currencyFormatDE(this.Items.jsonotherdonne.montantrecu),
                            montantmonnaie: this.calculMonnaie(this.Items.mtnt.docmtnttotalttc, this.Items.jsonotherdonne.montantrecu),
                            pourcentageprisenecharge: 0,
                            docsaisiepar: this.$store.state.appusername,
                            normalise,
                            mecefsignature,
                            mecefnim,
                            mecefcompteur,
                            mecefheure,
                            mecefqrr: urlimagegenerer,
                        };

                        this.$refs.modalfacturecomptoirepost.show(tabvalue, 'facture');
                    }
                    else {
                        let errormessage = "";
                        if (response.data.datamessage?.length > 0) {
                            errormessage = response.data.datamessage.join(", ");
                        } else {
                            errormessage = response.data.message;
                        }
                        this.messageerror = errormessage;
                        toastr['error'](this.messageerror);
                    }
                } catch (error) {
                    toastr['error']("Erreur de validation");
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            // ============ Cart Actions ============
            clearCart() {
                if (!confirm('Vider le panier ?')) return;
                this.listedatatable = [];
                this.calcullistedatatable();
            },

            Misecommandeenattente() {
                this.listedatatable = [];
                this.newArticle();
                this.initializeItems();
                toastr['success']("Commande mise en attente");
            },

            newinvoice() {
                this.listedatatable = [];
                this.newArticle();

                if (!this.conservationdesdonnees) {
                    this.initializeItems();
                } else {
                    const preserved = {
                        cltfrs: this.Items.jsonotherdonne?.cltfrs,
                        ifu: this.Items.jsonv?.ifu,
                        client: this.Items.jsonv?.client,
                        collaborateur: this.Items.jsonv?.collaborateur,
                        modereglement: this.Items.jsonv?.modereglement,
                        commandetable: this.Items.jsonv?.commandetable,
                    };

                    this.initializeItems();

                    this.Items.jsonotherdonne.cltfrs = preserved.cltfrs;
                    this.Items.jsonv.ifu = preserved.ifu;
                    this.Items.jsonv.client = preserved.client;
                    this.Items.jsonv.collaborateur = preserved.collaborateur;
                    this.Items.jsonv.modereglement = preserved.modereglement;
                    this.Items.jsonv.commandetable = preserved.commandetable;
                }
            },

            initializeItems() {
                this.Items = {
                    pid: '',
                    mag: null,
                    datedoc: this.$store.state.dateouverturecaisse,
                    docobservation: '',
                    docnum: '',
                    docnumother: '',
                    docpid: 0,
                    doctyp: '',
                    infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                    jsonotherdonne: {
                        montantrecu: 0,
                        tpdoc: "",
                        tredocument: "",
                        mtypprixdevente: "prixvente",
                        magvers: null,
                        collaborateur: null,
                        commandetable: null,
                        cltfrs: null,
                        moderglt: null,
                        cdtreglement: null,
                        appliquetva: 0,
                        aib: 0,
                        adresseexpedition: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                        infodoc: { infolibre: '', infolibre1: '', infolibre2: '', infolibre3: '' },
                    },
                    mtnt: {
                        montanthtassurance: 0,
                        docmtntaib: 0,
                        docmtntremise: 0,
                        docmtnttotalht: 0,
                        docmtnttotalttc: 0,
                        doctva: 0,
                        libaib: "AIB"
                    },
                    params: { param1: null, param2: null, param3: null, param4: null },
                    jsondoc: {},
                    jsonv: {
                        ifu: '',
                        client: '',
                        collaborateur: null,
                        modereglement: null,
                        commandetable: null,
                        indicateur: '',
                        indicateur1: '',
                        param: null,
                        param1: null,
                        isnormalisationetat: this.isNormalisationEtat,
                    }
                };
            },

            // ============ Data Loading ============
            async load() {
                const caisse = { cf: this.$store.state.caisseinfo, document: "FV" };

                try {
                    const url =`${process.env.VUE_APP_API_URL}/egl74587kjkjrfdkcaisse771714dfe/comptoire/caisse/${this.$store.state.caisseencour}/${this.$store.state.appsociete}/load895418init51comptoirerefdepdpcc11515/option2/${randomString(280)}`;
                    const response = await axios.post(url, caisse, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    this.datatable = response.data.success ? response.data.m : [];
                } catch (error) {
                    this.datatable = [];
                }
            },

            async loadreturnotherdata() {
                try {
                    const url =`${process.env.VUE_APP_API_URL}/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/other111dksdk/option2/${this.$store.state.appsociete}/${randomString()}`;
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    this.otherdatatable = response.data.success ? response.data.otherdata : {};
                } catch (error) {
                    this.otherdatatable = {};
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            async loadinputlibelleforms() {
                const savedData = JwtService.getVALUEDATAPRICE();

                if (isset(savedData)) {
                    this.datainputlibelleforms = JSON.parse(savedData);
                } else {
                    try {
                        const url =`${process.env.VUE_APP_API_URL}/12478855libelinputindex2iofdofiloadexp2/${this.$store.state.appsociete}/${randomString()}`;
                        const response = await axios.get(url, {
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + JwtService.getToken(),
                                'csrftoken': this.$store.state.appsociete
                            },
                            withCredentials: true
                        });

                        if (response.data.success) {
                            this.datainputlibelleforms = response.data.valuedataprice;
                            JwtService.setVALUEDATAPRICE(JSON.stringify(this.datainputlibelleforms));
                        }
                    } catch (error) {
                        this.datainputlibelleforms = [];
                    } finally {
                        this.$store.dispatch('lancerchargement', false);
                    }
                }
            },


            // ============ Keyboard Shortcuts ============
            handleKeydown(event) {
                if (event.code === 'F1') {
                    event.preventDefault();
                    if (this.selectedArticle) {
                        this.$refs.modalviewitemsdetails.show(this.selectedArticle);
                    }
                }

                if (event.code === 'F2') {
                    event.preventDefault();
                    this.focusBarcode();
                }

                if (event.code === 'F3') {
                    event.preventDefault();
                    this.openClientSelection();
                }

                if (event.code === 'F4') {
                    event.preventDefault();
                    this.openPaymentSelection();
                }

                if (event.code === 'F5') {
                    event.preventDefault();
                    this.newinvoice();
                }

                if (event.code === 'F6') {
                    event.preventDefault();
                    if (this.listedatatable.length) this.note();
                }

                if (event.code === 'F7') {
                    event.preventDefault();
                    if (this.listedatatable.length) this.Misecommandeenattente();
                }

                if (event.code === 'F12') {
                    event.preventDefault();
                    if (this.canValidate && this.compteprocess === 0) this.validateSale();
                }

                if (event.code === 'Escape') {
                    event.preventDefault();
                    this.showDropdown = false;
                    this.showArticleList = false;
                }
            },

            // ============ Pagination ============
            setPages(posts) {
                this.pages = [];
                const numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let i = 1; i <= numberOfPages; i++) {
                    this.pages.push(i);
                }
            },

            paginate(posts) {
                this.setPages(posts);
                const from = (this.page * this.perPage) - this.perPage;
                const to = this.page * this.perPage;
                const result = posts.slice(from, to);
                return result.length > 0 ? result : posts;
            }
        },


        setup(props) {
            // Injecter la méthode 'addCompte' provenant du parent
            const btnreinitialiserAllarticle = inject('reinitialiserAllarticle');
            const loadsoldecaisse = inject('loadsoldecaisse');


            const handlebtnreinitialiserAllarticle = () => {

                // Appel de la méthode injectée
                if (btnreinitialiserAllarticle) {
                    btnreinitialiserAllarticle();
                }

            };

            const handleloadsoldecaisse = () => {

                // Appel de la méthode injectée
                if (loadsoldecaisse) {
                    loadsoldecaisse();
                }

            };



            return {
                handlebtnreinitialiserAllarticle,
                handleloadsoldecaisse

            };
        },

        mounted() {
            if (!this.$store.state.caisseencour) {
                toastr['error']("Sélectionnez une caisse");
                this.$router.push({ name: 'tcaisse' });
                return;
            }

            this.initializeItems();
            this.loadinputlibelleforms();
            this.loadreturnotherdata();
            this.load();

            window.addEventListener('keydown', this.handleKeydown);
            this.$nextTick(() => this.focusBarcode());
        },

        beforeUnmount() {
            window.removeEventListener('keydown', this.handleKeydown);
        }
    };
</script>

<style scoped>
    /* ================================================
   CAISSE FACTURATION V2 - STYLES CSS
   Mobile-First, Optimisé pour écrans tactiles et scanners
   ================================================ */

    /* ===== CSS Variables ===== */
    .caisse-app {
        --primary: #3b82f6;
        --primary-hover: #2563eb;
        --success: #10b981;
        --success-hover: #059669;
        --warning: #f59e0b;
        --danger: #ef4444;
        --danger-hover: #dc2626;

        /* Light Mode */
        --bg-app: #f1f5f9;
        --bg-card: #ffffff;
        --bg-input: #f8fafc;
        --bg-hover: #f1f5f9;

        --text-primary: #1e293b;
        --text-secondary: #64748b;
        --text-muted: #94a3b8;

        --border: #e2e8f0;
        --shadow-sm: 0 1px 2px rgba(0,0,0,0.05);
        --shadow-md: 0 4px 6px -1px rgba(0,0,0,0.1);
        --shadow-lg: 0 10px 15px -3px rgba(0,0,0,0.1);

        --radius-sm: 6px;
        --radius-md: 10px;
        --radius-lg: 14px;
        --radius-xl: 20px;

        --transition: all 0.2s ease;
    }

    /* Dark Mode */
    .caisse-app.dark-mode {
        --bg-app: #0f172a;
        --bg-card: #1e293b;
        --bg-input: #334155;
        --bg-hover: #334155;

        --text-primary: #f1f5f9;
        --text-secondary: #94a3b8;
        --text-muted: #64748b;

        --border: #334155;
    }

    /* ===== Base Layout ===== */
    .caisse-app {
        display: flex;
        flex-direction: column;
        /*height: 100vh;*/
        height: max-content;
        background: var(--bg-app);
        color: var(--text-primary);
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        overflow: hidden;
    }

    /* ===== HEADER ===== */
    .mapp-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* padding: 12px 16px;*/
        padding: 0px 16px;
        background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);
        color: white;
        gap: 16px;
        flex-shrink: 0;
    }

    .mheader-brand {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .brand-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.2);
        border-radius: var(--radius-md);
        font-size: 20px;
    }

    .brand-info {
        display: flex;
        flex-direction: column;
    }

    .brand-title {
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 1px;
    }

    .brand-date {
        font-size: 12px;
        opacity: 0.8;
    }

    .header-balance {
        display: flex;
        flex-direction: column;
        align-items: center;
        /* padding: 8px 20px;*/
        padding: 5px 20px;
        background: rgba(255,255,255,0.15);
        border-radius: var(--radius-md);
        backdrop-filter: blur(10px);
    }

    .balance-label {
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        opacity: 0.8;
    }

    .balance-value {
        font-size: 18px;
        font-weight: 700;
    }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .action-btn-header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: rgba(255,255,255,0.15);
        border: none;
        border-radius: var(--radius-md);
        color: white;
        font-size: 18px;
        cursor: pointer;
        transition: var(--transition);
    }

    .action-btn-header:hover {
        background: rgba(255,255,255,0.25);
        transform: translateY(-1px);
    }

    .action-btn-header .badge {
        position: absolute;
        top: -4px;
        right: -4px;
        min-width: 18px;
        height: 18px;
        padding: 0 5px;
        background: var(--danger);
        border-radius: 50%;
        font-size: 11px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Dropdown */
    .dropdown-wrapper {
        position: relative;
    }

    .dropdown-panel {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        min-width: 220px;
        background: var(--bg-card);
        border-radius: var(--radius-md);
        box-shadow: var(--shadow-lg);
        overflow: hidden;
        z-index: 1000;
    }

    .dropdown-panel button {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 100%;
        padding: 12px 16px;
        background: none;
        border: none;
        font-size: 14px;
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
        text-align: left;
    }

    .dropdown-panel button:hover {
        background: var(--bg-hover);
    }

    .dropdown-panel button.danger {
        color: var(--danger);
    }

    .dropdown-panel button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .dropdown-panel hr {
        margin: 4px 0;
        border: none;
        border-top: 1px solid var(--border);
    }

    /* ===== ALERTS ===== */
    .alert {
        display: flex;
        align-items: center;
        gap: 12px;
        margin: 12px 16px 0;
        padding: 12px 16px;
        border-radius: var(--radius-md);
        font-size: 14px;
    }

    .alert.success {
        background: rgba(16, 185, 129, 0.15);
        color: var(--success);
        border: 1px solid rgba(16, 185, 129, 0.3);
    }

    .alert.error {
        background: rgba(239, 68, 68, 0.15);
        color: var(--danger);
        border: 1px solid rgba(239, 68, 68, 0.3);
    }

    .alert span {
        flex: 1;
    }

    .alert button {
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
        opacity: 0.6;
    }

    .alert button:hover {
        opacity: 1;
    }

    /* ===== MAIN LAYOUT ===== */
    .app-main {
        display: grid;
        /*grid-template-columns: 300px 1fr 260px;*/
        grid-template-columns: 300px 1fr 180px;
        gap: 16px;
        padding: 16px;
        flex: 1;
        overflow: hidden;
    }

    /* ===== LEFT PANEL (Scanner & Articles) ===== */
    .panel-left {
        display: flex;
        flex-direction: column;
        gap: 16px;
        overflow-y: auto;
    }

    .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-weight: 600;
        color: var(--text-primary);
    }

    .section-title i {
        font-size: 18px;
        color: var(--primary);
    }

    .section-title.clickable {
        cursor: pointer;
        padding: 12px;
        margin: -12px -12px 0;
        background: var(--bg-hover);
        border-radius: var(--radius-md) var(--radius-md) 0 0;
    }

    .section-title .toggle-icon {
        margin-left: auto;
        color: var(--text-muted);
    }

    /* Scanner Section */
    .scanner-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        padding: 16px;
        border: 1px solid var(--border);
    }

    /* Pre-scan Quantity Box */
    .prescan-box {
        background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);
        border-radius: var(--radius-md);
        padding: 12px;
        margin-bottom: 16px;
        color: white;
    }

    .prescan-box label {
        display: block;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 8px;
        opacity: 0.9;
    }

    .qty-stepper {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .qty-stepper button {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.2);
        border: none;
        border-radius: var(--radius-sm);
        color: white;
        font-size: 18px;
        cursor: pointer;
        transition: var(--transition);
    }

    .qty-stepper button:hover:not(:disabled) {
        background: rgba(255,255,255,0.3);
    }

    .qty-stepper button:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .qty-stepper input {
        flex: 1;
        height: 30px;
        background: white;
        border: none;
        border-radius: var(--radius-sm);
        font-size: 15px;
        font-weight: 700;
        text-align: center;
        color: var(--primary);
        max-width: 80%;
    }

    .qty-stepper input:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(255,255,255,0.3);
    }

    .prescan-box small {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-top: 8px;
        font-size: 11px;
        opacity: 0.8;
    }

    /* Input Groups */
    .input-group {
        position: relative;
        margin-bottom: 12px;
    }

    .input-group:last-child {
        margin-bottom: 0;
    }

    .input-group > i {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 18px;
        color: var(--text-muted);
        z-index: 1;
    }

    .input-group input {
        width: 100%;
        height: 48px;
        padding: 0 44px;
        background: var(--bg-input);
        border: 2px solid transparent;
        border-radius: var(--radius-md);
        font-size: 15px;
        color: var(--text-primary);
        transition: var(--transition);
    }

    .input-group input:focus {
        outline: none;
        border-color: var(--primary);
        background: var(--bg-card);
    }

    .input-group input::placeholder {
        color: var(--text-muted);
    }

    .input-group.barcode input {
        padding-right: 48px;
    }

    .scan-status {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: var(--text-muted);
        transition: var(--transition);
    }

    .scan-status.active {
        background: var(--success);
        box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.3);
    }

    .clear-input {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        font-size: 18px;
        color: var(--text-muted);
        cursor: pointer;
    }

    .clear-input:hover {
        color: var(--danger);
    }

    /* Articles Section */
    .articles-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        /*overflow: hidden;*/
        max-height: 500px;
        display: flex;
        flex-direction: column;
    }

    .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        background: var(--bg-hover);
        border-bottom: 1px solid var(--border);
        font-size: 13px;
        font-weight: 500;
        color: var(--text-secondary);
    }

    .section-header button {
        background: none;
        border: none;
        font-size: 18px;
        color: var(--text-muted);
        cursor: pointer;
    }

    .articles-grid {
        flex: 1;
        overflow-y: auto;
        padding: 8px;
    }

    .article-card {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 12px;
        margin-bottom: 6px;
        background: var(--bg-input);
        border-radius: var(--radius-md);
        cursor: pointer;
        transition: var(--transition);
        border: 2px solid transparent;
    }

    .article-card:hover {
        background: var(--bg-hover);
    }

    .article-card.selected {
        border-color: var(--primary);
        background: rgba(59, 130, 246, 0.1);
    }

    .article-main {
        flex: 1;
        min-width: 0;
    }

    .article-name {
        display: block;
        font-weight: 500;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .article-code {
        font-size: 11px;
        color: var(--text-muted);
    }

    .article-price {
        font-weight: 700;
        font-size: 14px;
        color: var(--danger);
        white-space: nowrap;
    }

    .quick-add {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background: var(--success);
        border: none;
        border-radius: 50%;
        color: white;
        font-size: 18px;
        cursor: pointer;
        transition: var(--transition);
        opacity: 0;
        transform: scale(0.8);
    }

    .article-card:hover .quick-add {
        opacity: 1;
        transform: scale(1);
    }

    .quick-add:hover {
        background: var(--success-hover);
    }

    /* Pagination */
    .pagination-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        padding: 12px;
        border-top: 1px solid var(--border);
    }

    .pagination-bar button {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
    }

    .pagination-bar button:hover:not(:disabled) {
        background: var(--primary);
        border-color: var(--primary);
        color: white;
    }

    .pagination-bar button:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .pagination-bar span {
        font-size: 13px;
        color: var(--text-secondary);
    }

    /* Client Section */
    .client-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        overflow: hidden;
    }

    .client-form {
        padding: 16px;
        padding-top: 8px;
    }

    .form-field {
        margin-bottom: 12px;
    }

    .form-field:last-child {
        margin-bottom: 0;
    }

    .form-field label {
        display: block;
        margin-bottom: 6px;
        font-size: 11px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: var(--text-secondary);
    }

    .form-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .form-field input,
    .form-field select {
        width: 100%;
        height: 40px;
        padding: 0 12px;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        font-size: 14px;
        color: var(--text-primary);
        transition: var(--transition);
    }

    .form-field input:focus,
    .form-field select:focus {
        outline: none;
        border-color: var(--primary);
    }

    /* ===== CENTER PANEL (Cart) ===== */
    .panel-center {
        display: flex;
        flex-direction: column;
        min-height: 0;
        /*height: 600px;
        overflow: scroll;*/
    }

    .cart-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        /* overflow: hidden;*/
    }

    .cart-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px;
        background: linear-gradient(135deg, var(--danger) 0%, var(--danger-hover) 100%);
        color: white;
    }

    .cart-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 600;
    }

    .cart-title i {
        font-size: 20px;
    }

    .cart-count {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 24px;
        padding: 0 8px;
        background: rgba(255,255,255,0.2);
        border-radius: 50px;
        font-size: 13px;
        font-weight: 700;
    }

    .clear-cart {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background: rgba(255,255,255,0.15);
        border: none;
        border-radius: var(--radius-md);
        color: white;
        font-size: 18px;
        cursor: pointer;
        transition: var(--transition);
    }

    .clear-cart:hover {
        background: rgba(255,255,255,0.25);
    }

    /* Cart Items */
    .cart-items {
        flex: 1;
        overflow-y: auto;
        padding: 12px;
        max-height: 350px;
    }

    .cart-item {
        display: grid;
        grid-template-columns: 28px 1fr auto auto;
        gap: 10px;
        align-items: center;
        padding: 12px;
        margin-bottom: 8px;
        background: var(--bg-input);
        border-radius: var(--radius-md);
        border-left: 3px solid transparent;
        transition: var(--transition);
    }

    .cart-item.status-success {
        border-left-color: var(--success);
    }

    .cart-item.status-error {
        border-left-color: var(--danger);
        background: rgba(239, 68, 68, 0.1);
    }

    .cart-item.status-pending {
        border-left-color: var(--warning);
    }

    .item-status {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .item-status .success {
        color: var(--success);
        font-size: 18px;
    }

    .item-status .error {
        color: var(--danger);
        font-size: 18px;
    }

    .spinner-small {
        width: 16px;
        height: 16px;
        border: 2px solid var(--border);
        border-top-color: var(--primary);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to { transform: rotate(360deg); }
    }

    .item-info {
        min-width: 0;
    }

    .item-name {
        display: block;
        font-weight: 500;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item-name small {
        font-weight: 400;
        color: var(--text-muted);
    }

    .item-details {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--text-secondary);
        margin-top: 2px;
    }

    .item-details .discount {
        color: var(--danger);
        font-weight: 500;
    }

    .item-total {
        font-weight: 700;
        font-size: 14px;
        white-space: nowrap;
    }

    .item-actions {
        display: flex;
        gap: 4px;
    }

    .item-actions button {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        border-radius: var(--radius-sm);
        font-size: 16px;
        cursor: pointer;
        transition: var(--transition);
    }

    .item-actions button:first-child {
        color: var(--primary);
    }

    .item-actions button:first-child:hover {
        background: rgba(59, 130, 246, 0.15);
    }

    .item-actions button:last-child {
        color: var(--danger);
    }

    .item-actions button:last-child:hover {
        background: rgba(239, 68, 68, 0.15);
    }

    .item-error {
        grid-column: 1 / -1;
        margin-top: 8px;
        padding: 8px;
        background: rgba(239, 68, 68, 0.1);
        border-radius: var(--radius-sm);
        font-size: 12px;
        color: var(--danger);
    }

    /* Cart Empty */
    .cart-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 48px 24px;
        text-align: center;
    }

    .cart-empty i {
        font-size: 64px;
        color: var(--text-muted);
        opacity: 0.3;
        margin-bottom: 16px;
    }

    .cart-empty p {
        font-size: 18px;
        font-weight: 600;
        color: var(--text-secondary);
        margin-bottom: 8px;
    }

    .cart-empty small {
        font-size: 14px;
        color: var(--text-muted);
    }

    /* Cart Footer */
    .cart-footer {
        padding: 16px;
        background: var(--bg-hover);
        border-top: 1px solid var(--border);
    }

    .totals-section {
        margin-bottom: 16px;
    }

    .total-line {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        font-size: 14px;
        color: var(--text-secondary);
    }

    .total-line.discount {
        color: var(--danger);
    }

    .total-line.grand {
        padding-top: 12px;
        margin-top: 8px;
        border-top: 2px dashed var(--border);
        font-size: 16px;
        font-weight: 700;
        color: var(--text-primary);
    }

    .total-line.grand span:last-child {
        font-size: 24px;
        color: var(--success);
    }

    /* Payment Section */
    .payment-section {
        margin-bottom: 16px;
    }

    .payment-field {
        margin-bottom: 12px;
    }

    .payment-field label {
        display: block;
        margin-bottom: 6px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        color: var(--text-secondary);
    }

    .payment-input-wrap {
        position: relative;
    }

    .payment-input-wrap input {
        width: 100%;
        height: 52px;
        padding: 0 40px 0 16px;
        background: var(--bg-card);
        border: 2px solid var(--border);
        border-radius: var(--radius-md);
        font-size: 22px;
        font-weight: 700;
        color: var(--text-primary);
        transition: var(--transition);
    }

    .payment-input-wrap input:focus {
        outline: none;
        border-color: var(--primary);
    }

    .currency-suffix {
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        font-weight: 600;
        color: var(--text-muted);
    }

    .change-display {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        background: rgba(16, 185, 129, 0.1);
        border-radius: var(--radius-md);
        margin-bottom: 12px;
    }

    .change-display.negative {
        background: rgba(239, 68, 68, 0.1);
    }

    .change-display span:first-child {
        font-size: 13px;
        color: var(--text-secondary);
    }

    .change-value {
        font-size: 20px;
        font-weight: 700;
        color: var(--success);
    }

    .change-display.negative .change-value {
        color: var(--danger);
    }

    /* Quick Amounts */
    .quick-amounts {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
    }

    .quick-amounts button {
        flex: 1;
        min-width: 60px;
        padding: 8px 12px;
        background: var(--bg-card);
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        font-size: 13px;
        font-weight: 600;
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
    }

    .quick-amounts button:hover {
        background: var(--primary);
        border-color: var(--primary);
        color: white;
    }

    .quick-amounts button.exact {
        background: var(--success);
        border-color: var(--success);
        color: white;
    }

    /* Validate Button */
    .validate-btn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 16px 24px;
        background: linear-gradient(135deg, var(--success) 0%, var(--success-hover) 100%);
        border: none;
        border-radius: var(--radius-md);
        font-size: 16px;
        font-weight: 700;
        color: white;
        cursor: pointer;
        transition: var(--transition);
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .validate-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
    }

    .validate-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .validate-btn kbd {
        padding: 4px 8px;
        background: rgba(255,255,255,0.2);
        border-radius: var(--radius-sm);
        font-size: 12px;
    }

    /* ===== RIGHT PANEL ===== */
    .panel-right {
        display: flex;
        flex-direction: column;
        gap: 16px;
        overflow-y: auto;
    }

    /* Numpad */
    .numpad-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        padding: 12px;
    }

    .numpad-display {
        padding: 12px 16px;
        background: var(--bg-input);
        border-radius: var(--radius-md);
        margin-bottom: 12px;
        text-align: right;
        font-size: 24px;
        font-weight: 700;
        font-family: 'JetBrains Mono', monospace;
    }

    .numpad-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
    }

    .numpad-grid button {
        height: 44px;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        font-size: 18px;
        font-weight: 600;
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
    }

    .numpad-grid button:hover {
        background: var(--primary);
        border-color: var(--primary);
        color: white;
    }

    .numpad-grid button.action {
        background: var(--warning);
        border-color: var(--warning);
        color: white;
    }

    .numpad-actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        margin-top: 8px;
    }

    .numpad-actions button {
        padding: 10px;
        background: var(--primary);
        border: none;
        border-radius: var(--radius-sm);
        font-size: 12px;
        font-weight: 600;
        color: white;
        cursor: pointer;
        transition: var(--transition);
    }

    .numpad-actions button:hover {
        background: var(--primary-hover);
    }

    /* Quick Actions */
    .quick-actions-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .quick-actions-section button {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: var(--radius-md);
        font-size: 13px;
        font-weight: 500;
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
    }

    .quick-actions-section button:hover:not(:disabled) {
        background: var(--primary);
        border-color: var(--primary);
        color: white;
    }

    .quick-actions-section button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .quick-actions-section button i {
        font-size: 18px;
    }

    .quick-actions-section button span {
        flex: 1;
        text-align: left;
    }

    .quick-actions-section button kbd {
        padding: 2px 6px;
        background: var(--bg-card);
        border-radius: var(--radius-sm);
        font-size: 11px;
        color: var(--text-muted);
    }

    .quick-actions-section button:hover kbd {
        background: rgba(255,255,255,0.2);
        color: white;
    }

    /* Settings */
    .settings-section {
        background: var(--bg-card);
        border-radius: var(--radius-lg);
        border: 1px solid var(--border);
        padding: 16px;
    }

    .setting-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid var(--border);
    }

    .setting-row:last-child {
        border-bottom: none;
    }

    .setting-row span {
        font-size: 13px;
        color: var(--text-secondary);
    }

    /* Toggle Switch */
    .switch {
        position: relative;
        width: 44px;
        height: 24px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        inset: 0;
        background: var(--bg-input);
        border-radius: 50px;
        transition: var(--transition);
    }

    .slider::before {
        content: '';
        position: absolute;
        left: 2px;
        top: 2px;
        width: 20px;
        height: 20px;
        background: white;
        border-radius: 50%;
        transition: var(--transition);
        box-shadow: var(--shadow-sm);
    }

    .switch input:checked + .slider {
        background: var(--success);
    }

    .switch input:checked + .slider::before {
        transform: translateX(20px);
    }

    .switch input:disabled + .slider {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* ===== FOOTER ===== */
    .app-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        padding: 10px 16px;
        background: var(--bg-card);
        border-top: 1px solid var(--border);
        flex-shrink: 0;
    }

    .shortcut {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: var(--text-muted);
    }

    .shortcut kbd {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 22px;
        padding: 0 6px;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: 4px;
        font-size: 11px;
        font-weight: 600;
        color: var(--text-secondary);
    }

    /* ===== ANIMATIONS ===== */
    .fade-slide-enter-active,
    .fade-slide-leave-active {
        transition: all 0.2s ease;
    }

    .fade-slide-enter-from,
    .fade-slide-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }

    .alert-slide-enter-active,
    .alert-slide-leave-active {
        transition: all 0.3s ease;
    }

    .alert-slide-enter-from,
    .alert-slide-leave-to {
        opacity: 0;
        transform: translateY(-20px);
    }

    .expand-enter-active,
    .expand-leave-active {
        transition: all 0.3s ease;
        overflow: hidden;
    }

    .expand-enter-from,
    .expand-leave-to {
        opacity: 0;
        max-height: 0;
    }

    .cart-item-enter-active {
        animation: slideIn 0.3s ease;
    }

    .cart-item-leave-active {
        animation: slideOut 0.3s ease;
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateX(30px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @keyframes slideOut {
        from {
            opacity: 1;
            transform: translateX(0);
        }
        to {
            opacity: 0;
            transform: translateX(-30px);
        }
    }

    /* ===== SCROLLBAR ===== */
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: var(--text-muted);
        border-radius: 50px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: var(--text-secondary);
    }

    /* ===== RESPONSIVE ===== */
    @media (max-width: 1200px) {
        .app-main {
            grid-template-columns: 280px 1fr 240px;
        }
    }

    @media (max-width: 992px) {
        .app-main {
            grid-template-columns: 1fr;
            grid-template-rows: auto 1fr auto;
        }

        .panel-left { order: 1; }
        .panel-center { order: 2; min-height: 400px; overflow-y: auto; }
        .panel-right { order: 3; flex-direction: row; flex-wrap: wrap; }

        .numpad-section,
        .quick-actions-section,
        .settings-section {
            flex: 1;
            min-width: 200px;
        }

        .quick-actions-section {
            flex-direction: row;
            flex-wrap: wrap;
        }

        .quick-actions-section button {
            flex: 1 1 45%;
        }

        .app-footer {
            display: none;
        }
    }

    @media (max-width: 768px) {
        .mapp-header {
            flex-wrap: wrap;
            gap: 12px;
        }

        .mheader-brand { order: 1; flex: 1; }
        .header-balance { order: 3; flex: 1 1 100%; justify-content: center; }
        .header-actions { order: 2; }

        .app-main {
            padding: 12px;
            gap: 12px;
        }

        .articles-section {
            max-height: 300px;
        }

        .numpad-section {
            display: none;
        }

        .total-line.grand span:last-child {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        .brand-title {
            font-size: 16px;
        }

        .balance-value {
            font-size: 16px;
        }

        .header-balance {
            padding: 6px 12px;
        }

        .action-btn-header {
            width: 36px;
            height: 36px;
        }

        .prescan-box {
            padding: 10px;
        }

        .qty-stepper input {
            font-size: 18px;
            height: 36px;
        }

        .form-row {
            grid-template-columns: 1fr;
        }

        .quick-amounts button {
            min-width: 50px;
            padding: 6px 8px;
            font-size: 12px;
        }

        .validate-btn {
            padding: 14px;
            font-size: 14px;
        }

        .panel-right {
            flex-direction: column;
        }

        .quick-actions-section {
            flex-direction: column;
        }

        .quick-actions-section button {
            flex: none;
        }
    }


    /* ===== FLOATING ACTION BUTTONS ===== */
    .fab-container {
        position: fixed;
        bottom: 80px;
        right: 20px;
        z-index: 50;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
    }

    .fab-main {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        box-shadow: var(--shadow-xl);
        transition: var(--transition);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1001;
    }

    .fab-main:hover {
        transform: scale(1.1);
        box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
    }

    .fab-main.active {
        transform: rotate(45deg);
    }

    .fab-item {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: none;
        color: white;
        font-size: 20px;
        cursor: pointer;
        box-shadow: var(--shadow-md);
        transition: var(--transition);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .fab-item.client {
        background: linear-gradient(135deg, var(--success) 0%, var(--success-hover) 100%);
    }

    .fab-item.payment {
        background: linear-gradient(135deg, var(--warning) 0%, #eab308 100%);
    }

    .fab-item.options {
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    }

    .fab-item.quick-note {
        background: linear-gradient(135deg, var(--danger) 0%, var(--danger-hover) 100%);
    }

    .fab-item:hover {
        transform: translateY(-2px) scale(1.05);
    }

    .fab-item:hover .fab-label {
        opacity: 1;
        transform: translateX(0);
        pointer-events: auto;
    }

    .fab-label {
        position: absolute;
        right: 60px;
        background: var(--bg-card);
        color: var(--text-primary);
        padding: 6px 12px;
        border-radius: var(--radius-sm);
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
        box-shadow: var(--shadow-md);
        opacity: 0;
        transform: translateX(10px);
        transition: var(--transition);
        pointer-events: none;
    }

    .fab-item:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
    }

    .fab-item:disabled:hover {
        transform: none;
    }


    .fab-item-enter-active {
        animation: fabIn 0.3s ease forwards;
    }

    .fab-item-leave-active {
        animation: fabOut 0.2s ease forwards;
    }

    @keyframes fabIn {
        from {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes fabOut {
        from {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
        to {
            opacity: 0;
            transform: translateY(20px) scale(0.8);
        }
    }


    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;
        animation: fadeIn 0.2s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .modal-content {
        background: var(--bg-card);
        border-radius: var(--radius-xl);
        width: 90%;
        max-width: 500px;
        max-height: 80vh;
        overflow: hidden;
        box-shadow: var(--shadow-xl);
        animation: slideUp 0.3s ease;
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 24px;
        background: var(--bg-hover);
        border-bottom: 1px solid var(--border);
    }

    .modal-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: var(--text-primary);
    }

    .modal-close {
        background: none;
        border: none;
        font-size: 24px;
        color: var(--text-muted);
        cursor: pointer;
        transition: var(--transition);
    }

    .modal-close:hover {
        color: var(--danger);
    }

    .modal-body {
        padding: 24px;
        overflow-y: auto;
        max-height: calc(80vh - 80px);
    }

    .client-modal-form {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .payment-methods {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 12px;
    }

    .payment-method {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding: 16px;
        background: var(--bg-input);
        border: 2px solid var(--border);
        border-radius: var(--radius-md);
        cursor: pointer;
        transition: var(--transition);
    }

    .payment-method:hover {
        background: var(--bg-hover);
        border-color: var(--primary);
    }

    .payment-method.selected {
        background: rgba(59, 130, 246, 0.1);
        border-color: var(--primary);
    }

    .payment-method i {
        font-size: 24px;
        color: var(--primary);
    }

    .payment-method span {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
    }

    .options-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .option-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        background: var(--bg-input);
        border: 1px solid var(--border);
        border-radius: var(--radius-md);
        font-size: 14px;
        color: var(--text-primary);
        cursor: pointer;
        transition: var(--transition);
    }

    .option-item:hover {
        background: var(--bg-hover);
        border-color: var(--primary);
        transform: translateX(4px);
    }

    .option-item i {
        font-size: 18px;
        color: var(--primary);
    }



</style>

